import React, { FC, useCallback, useEffect, useState } from 'react'

import BlobUtil from '@/utils/blobUtil'

import Image, { ImageProps } from '../Image'

type ImageStreamLoaderFN = (signal: AbortController) => Promise<Blob>

type Props = Omit<ImageProps, 'src'> & {
  loader: ImageStreamLoaderFN
}

const ImageStream: FC<Props> = ({ loader, ...props }) => {
  const [imageSrc, setImageSrc] = useState<string>()

  const getURL = useCallback(
    async (controller: AbortController) => {
      const response = await loader(controller)
      const objectURL = await BlobUtil.toDataUrl(response)
      setImageSrc(objectURL)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  useEffect(() => {
    const controller = new AbortController()
    getURL(controller)

    return () => {
      controller.abort()
    }
  }, [getURL])

  useEffect(() => {
    return () => {
      if (imageSrc) {
        URL.revokeObjectURL(imageSrc)
      }
    }
  }, [imageSrc])

  return (
    <Image
      src={imageSrc}
      {...props}
    />
  )
}

export type { ImageStreamLoaderFN }

export default ImageStream
